import React from "react";
import { Menu, Dropdown, Avatar } from "antd";
import { connect } from 'react-redux'
import { 
  EditOutlined,
  LogoutOutlined 
} from '@ant-design/icons';
import Icon from 'components/util-components/Icon';
import { signOut } from 'redux/actions/Auth';
import { FIRST_NAME, LAST_NAME, DEPT_DESCRIPTION, AVATAR } from 'redux/constants/Auth' 
import Utils from "utils";

const menuItem = [
	{
		title: "Modifica Profilo",
		icon: EditOutlined ,
		path: "/profile"
    },
    /*
    {
		title: "Account Setting",
		icon: SettingOutlined,
		path: "/"
    },
    {
		title: "Billing",
		icon: ShopOutlined ,
		path: "/"
	},
    {
		title: "Help Center",
		icon: QuestionCircleOutlined,
		path: "/"
	}*/
]

export const NavProfile = ({signOut}) => {
  const profileImg = `data:image/jpeg;base64,${localStorage.getItem(AVATAR)}`// "/img/avatars/thumb-1.jpg";
  const profileMenu = (
    <div className="nav-profile nav-dropdown">
      <div className="nav-profile-header">
        <div className="d-flex">
          <div>
            <Avatar size={45} src={profileImg} />
          </div>
          <div className="pl-3">
            <h4 className="mb-0">{localStorage.getItem(FIRST_NAME)} {localStorage.getItem(LAST_NAME)}</h4>
            <span className="text-muted">{localStorage.getItem(DEPT_DESCRIPTION)}</span>
          </div>
        </div>
      </div>
      <div className="nav-profile-body">
        <Menu>
          {!Utils.CurrentUserEndorsable() && Utils.CurrentUserApplication() === "SAMAC" && menuItem.map((el, i) => {
            return (
              <Menu.Item key={i}>
                <a href={el.path}>
                  <Icon type={el.icon} />
                  <span className="font-weight-normal">{el.title}</span>
                </a>
              </Menu.Item>
            );
          })}
          <Menu.Item key={menuItem.length + 1} onClick={e => signOut()}>
            <span>
              <LogoutOutlined />
              <span className="font-weight-normal">Esci</span>
            </span>
          </Menu.Item>
        </Menu>
      </div>
    </div>
  );
  return (
    <Dropdown placement="bottomRight" overlay={profileMenu} trigger={["click"]}>
      <Menu className="d-flex align-item-center" mode="horizontal">
        <Menu.Item key="profile">
          <Avatar src={profileImg} />
        </Menu.Item>
      </Menu>
    </Dropdown>
  );
}

export default connect(null, {signOut})(NavProfile)
